import React from 'react';

import CommonImage from '@/components/CommonImage';

const BuyerRequestModal = () => {
	return (
		<div className="popup-wrapper material-requirement-modal width-784-dialog">
			<div className="common-popup">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-14 mb-0">
							Add material(s) that is closest to the requirement
						</h3>
					</div>
					<div className="close-btn">
						<img src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label body-scroll">
					{/* <div className="empty-section pt-4">
						<div className="empty-section-content d-flex justify-content-center align-items-center">
							<p className="regular-14 gray-dark-02 mr-2">No material added.</p>
							<button className="button size32">Add Material</button>
						</div>
					</div> */}
					<div className="material-requirement-table">
						<table className="table height-sm hover with-border">
							<thead>
								<tr>
									<th>Fabric Type</th>
									<th>Fabric details</th>
									<th>Requirement</th>
									<th>Total estimated price</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Knit</td>
									<td>
										<p>Color : TX - CC113</p>
										<p>Composition : 100% Cotton</p>
									</td>
									<td>1000 YRD</td>
									<td>1000 YRD</td>
									<td>
										<div className="action-icon cursor-pointer">
											<CommonImage src="/icons/delete_gray.svg" width={20} />
										</div>
										<span className="regular-14 blue cursor-pointer">Update</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className="row">
						<div className="col-md-4 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Fabric Type*</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-4 pr-2">
							<div className="form-group">
								<label htmlFor="gsm">GSM</label>
								<input type="number" placeholder="GSM" />
							</div>
						</div>
						<div className="col-md-4">
							<div className="form-group composition-item weight-item mb-0">
								<label>Required amount</label>
								<div className="d-flex">
									<input
										className="input-percentage"
										max={100}
										min="0.1"
										type="number"
										defaultValue
									/>

									<div className="select-component">
										<div className="form-group size36">
											<div className="select-component">
												<div
													className="click-box click mb-1"
													data-toggle="dropdown"
													tabIndex={0}
												>
													<p className="regular-14 ">GMV</p>
													<img alt="" src=" /images/chevron_down.svg" />
												</div>
												<div data-testid="wrapper">
													<div className="dropdown-box  dropdown-menu">
														<div className="m-0 search-filter">
															<div className="with-icon right-icon">
																<input
																	autoComplete="off"
																	placeholder="Composition"
																	type="text"
																	defaultValue
																/>
																<span className="right-icon">
																	<img src=" /icons/search.png" />
																</span>
															</div>
														</div>
														<div className="color-list-box">
															<li className="single-color-item single-item d-flex ">
																<span
																	className="single-item-focus"
																	tabIndex={0}
																>
																	Nylon
																</span>
															</li>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className="form-group composition-item weight-item mb-0">
								<label>Required amount</label>
								<div className="d-flex">
									<input
										className="input-percentage"
										max={100}
										min="0.1"
										type="number"
										defaultValue
									/>

									<div className="select-component">
										<div className="form-group size36">
											<div className="select-component">
												<div
													className="click-box click mb-1"
													data-toggle="dropdown"
													tabIndex={0}
												>
													<p className="regular-14 ">GMV</p>
													<img alt="" src=" /images/chevron_down.svg" />
												</div>
												<div data-testid="wrapper">
													<div className="dropdown-box  dropdown-menu">
														<div className="m-0 search-filter">
															<div className="with-icon right-icon">
																<input
																	autoComplete="off"
																	placeholder="Composition"
																	type="text"
																	defaultValue
																/>
																<span className="right-icon">
																	<img src=" /icons/search.png" />
																</span>
															</div>
														</div>
														<div className="color-list-box">
															<li className="single-color-item single-item d-flex ">
																<span
																	className="single-item-focus"
																	tabIndex={0}
																>
																	Nylon
																</span>
															</li>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group cost-group">
								<label for="custom-input">Cost (BDT)</label>
								<div class="with-icon right-icon">
									<input
										id="custom-input"
										type="text"
										placeholder="Placeholder Text"
										aria-invalid="true"
										aria-describedby="input-error input-count"
									/>
									<span class="right-icon border-left h-100 text-center">
										<span className="gray-dark-02 regular-14">৳</span>
									</span>
								</div>
							</div>
						</div>
					</div>
					{/* repeat row */}
					<div className="row repeat-row">
						<div className="col-md-1">
							<button className="button gray-outline size36">
								<CommonImage src="/icons/minus.svg" />
							</button>
						</div>
						<div className="col-md-5 pr-2">
							<div className="form-group">
								<div className="select-component">
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 ">
							<div className="form-group">
								<input type="number" placeholder="Enter %" />
							</div>
						</div>
					</div>
					<div className="row repeat-row">
						<div className="col-md-1">
							<button className="button gray-outline size36">
								<CommonImage src="/icons/minus.svg" />
							</button>
						</div>
						<div className="col-md-5 pr-2">
							<div className="form-group">
								<div className="select-component">
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 ">
							<div className="form-group">
								<input type="number" placeholder="Enter %" />
							</div>
						</div>
					</div>
				</div>

				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuyerRequestModal;
